(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('spendSummary', spendSummary);

	spendSummary.$inject = ['$scope',  '$timeout', '$rootScope', '$state', '$location', 'redirectParamsService',
		'leanFilterService', 'currencyFormatService', 'tableService', 'navigationService', 'pageTimingService', 'site_url',
		'tableRenderService', 'storeService', '$experiments'];

	function spendSummary($scope,  $timeout, $rootScope, $state, $location, redirectParamsService,
			leanFilterService, currencyFormatService, tableService, navigationService, pageTimingService, site_url,
			tableRenderService, storeService, $experiments) {
		var vm = this;
		var unsubscribe;

		var showWhitelistFilter = $experiments.isEnabled('workbench');
		var	customerNdx = globalConfig.customer.id;
		var isSupplier = globalConfig.user.role === 'Supplier';
		var factories = _.toArray(globalConfig.user.authFacts).filter(function(factory) {
			return (isSupplier ? factory.roleType === 'Supplier' : factory.roleType !== 'Supplier') && factory.customerNdx === customerNdx;
		}).sort(function (factoryA, factoryB) {
			// Sort alphabetically ascending (case sensitive)
			// e.g. Triumph MSF, Triumph MVO, Triumph Mexicali
			// This sort is case sensitive because the current backend uses a case sensitive sort
			return (factoryA.alias || factoryA.name) < (factoryB.alias || factoryB.name) ? -1 : 1;
		});
		var businessUnits = [];
		var divisions = [];
		var entities = [];
		factories.forEach(function (factory) {
			var businessUnit = factory.businessunit && removeUnwantedCharsFromColIds(factory.businessunit);
			var division = factory.division && removeUnwantedCharsFromColIds(factory.division);
			var entity = factory.entity && removeUnwantedCharsFromColIds(factory.entity);
			if (businessUnit && businessUnits.indexOf(businessUnit) === -1) {
				businessUnits.push(businessUnit);
			}
			if (division && divisions.indexOf(division) === -1) {
				divisions.push(division);
			}
			if (entity && entities.indexOf(entity) === -1) {
				entities.push(entity);
			}
		});

		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;
		var setFirstView = false;
		var reportName = 'Spend summary: Supplier spend';
		var rendererParams = {
			currencyFormatter: currencyFormatService,
			state: $state,
			'siteUrl': site_url
		};

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		var reportSettingsName = 'spend-summary/supplier-spend';
		var groupBy = 'supplierCode';
		vm.buildHeaderMap = {};
		if ($state.current.name === 'app.supply-chain.spend-summary/material-group-spend') {
			reportSettingsName = 'spend-summary/material-group-spend';
			groupBy = 'materialGroup';
			reportName = 'Spend summary: Material group spend';
		} else if ($state.current.name === 'app.supply-chain.spend-summary/item-group-spend') {
			reportSettingsName = 'spend-summary/item-group-spend';
			groupBy = 'itemGroup';
			reportName = 'Spend summary: Item group spend';
		}

		var pinnedColumns = [];
		var defaultFilters = [];
		// Extra query params to send to backend in data requests
		var extraParams = [
			{ 'name': 'groupBy', 'value': groupBy }
		];
		// Extra drilldown query params to parse
		var extraFilters = [];
		vm.reportName = reportName;
		vm.showExcel = true;
		vm.initialLoad = true;
		$scope.useNewExport = true;

		var columns = [];

		$scope.filterService = leanFilterService;

		init();
		var reportGroup = 'spend-summary';
		var reportKey = groupBy === 'materialGroup' ? 'material-group-spend' : 
			(groupBy === 'itemGroup' ? 'item-group-spend' : 'supplier-spend');
		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: reportName,
			reportUrl: '{0}/SpendSummaryReport/' + reportGroup + '/' + reportKey,
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'totalForAll',
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			hideSearch: true,
			setColumnDefaults: true,
			hasMandatoryFilters: true,
			waitForFilters: true,
			useReportBuilderForExcel: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}


		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true});
		}

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});

		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams, isFilterChanged) {
			return tableService.postData(params, extraParams, columns).then(function (response) {
				if (!reportSettingsId && !setFirstView) {
					var firstViewObj = {
						'viewType': $state.current.data.viewType
					};
					navigationService.setFirstView(firstViewObj, reportSettingsName);
					setFirstView = true;
				}

				if ((isFilterChanged && isFilterChanged === 'filtersChanged') || vm.initialLoad) {
					if (vm.initialLoad) {
						vm.initialLoad = false;
					}
					changeColumnDisplay(response);
					response.refreshMeta = true;
				}
				getDataCalled = true;
				submitUserTiming();
				return response;
			});
		}

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming('Shortages by Item');
				timingCalled = true;
			}
		}

		function changeColumnDisplay(response) {
			if (!response[0]) {
				return;
			}
			if (response[0] && response[1]) {
				tableRenderService.clearSpendSummaryHeaderMap();
				vm.headerTotals = response[0].headerTotals;
				vm.targetCurrency = response[0].targetCurrency;
				vm.responseTotal = response[1];
				vm.headerTotals = _.sortBy(vm.headerTotals, 'name');
				rendererParams['headerTotals'] = vm.headerTotals;
				updateHeaderTotals();
				disableHierarchyColumns();
				var viewBy = 'Site';
				var viewByFilter = storeService.getState().reportSettings.filters.find(function (filter) {
					return filter.id === 'viewByBuDivisionEntitySite';
				});
				if (viewByFilter) {
					var selected = viewByFilter.values[0];
					if (selected === 'businessUnit') {
						viewBy = 'BU';
					} else if (selected === 'division') {
						viewBy = 'Division';
					} else if (selected === 'entity') {
						viewBy = 'Entity';
					}
				}
				for (var i = 0; i < vm.headerTotals.length; i++) {
					var factoryNdx = vm.headerTotals[i].leanDirFactoryNdx;
					var name = removeUnwantedCharsFromColIds(vm.headerTotals[i].name);
					var idEnd = viewBy === 'Site' ? factoryNdx : viewBy + name;
					var id = 'Sum' + idEnd;
					var defaultId = 'Sum' + vm.headerTotals[i].id;
					var headerTotal = getHeaderTotal(vm.headerTotals[i].id, response[0]);
					var name = vm.headerTotals[i].name;
					updateColumn(id, {
						disabled: false,
						display: name + '<br/>' + headerTotal,
						displayText: name,
						defaultId: defaultId,
						renderer: tableRenderService.factorySpendRenderer
					});
				}
			}
		}

		function getHeaderTotal(headerId) {
			var result = 0;
			var total = 0;
			var headerTotals = vm.headerTotals;
			var targetCurrency = vm.targetCurrency;
			var responseTotal = vm.responseTotal;
			for (var i = 0; i < headerTotals.length; i++) {
				var row = headerTotals[i];
				total += row.factoryTotal;
				if (row.id == headerId) {
					result = row.factoryTotal;
					break;
				}
			}
			if (headerId == 'allFactories')
				return currencyFormatService.getWithParametersNegativeSign(total, 0, targetCurrency);
			if (headerId == 'futurePPV') {
				if (typeof responseTotal.futurePPV === 'undefined') {
					return '';
				}
				return currencyFormatService.getWithParametersNegativeSign(responseTotal.futurePPV, 0, targetCurrency);
			}
			if (headerId == 'ppv') {
				if (typeof responseTotal.ppv === 'undefined') {
					return '';
				}
				return currencyFormatService.getWithParametersNegativeSign(responseTotal.ppv, 0, targetCurrency);
			}
			return currencyFormatService.getWithParametersNegativeSign(result, 0, targetCurrency);
		}

		function disableHierarchyColumns() {
			columns.forEach(function (col) {
				if (col.id.indexOf('Sum') === 0) {
					col.disabled = true;
				}
			});
		}

		function updateColumn(colId, changes) {
			var column = columns.find(function (col) {
				return col.id === colId;
			}) || pinnedColumns.find(function (col) {
				return col.id === colId;
			});
			if (column) {
				column = Object.assign(column, changes);
			}
		}

		function updateHeaderTotals() {
			var fiscalYear = storeService.getState().reportSettings.filters.find(function (filter) {
				return filter.id === 'fiscalYear';
			});
			var isPreviousFiscalYear = fiscalYear && fiscalYear.values && fiscalYear.values[0] === 'previous';
			var allFactoriesTotal = getHeaderTotal('allFactories');
			var ppvTotal = getHeaderTotal('ppv');
			var previousPpvTotal = isPreviousFiscalYear ? ppvTotal : '';
			var currentPpvTotal = isPreviousFiscalYear ? '' : ppvTotal;
			var futurePpvTotal = getHeaderTotal('futurePPV');
			updateColumn('totalForAll', { 'display': 'Total<br/>' + allFactoriesTotal });
			updateColumn('ppvBaselinePreviousFiscalYear', { 'display': 'PPV Previous Fiscal Year<br />' + previousPpvTotal, 'disabled': !isPreviousFiscalYear });
			updateColumn('ppvBaselineCurrentFiscalYear', { 'display': 'PPV Current Fiscal Year<br />' + currentPpvTotal, 'disabled': isPreviousFiscalYear });
			updateColumn('futurePPV', { 'display': 'Future PPV<br/>' + futurePpvTotal });
		}

		function removeUnwantedCharsFromColIds(str) {
			// Backend does not allow column ids to contain certain characters
			return str.replace(/\s/g , '_').replace(/[^a-zA-Z0-9_@]/g, '');
		}

		function setDefaultColumns(initialLoad) {
			columns = [];
			if ($state.current.name === 'app.supply-chain.spend-summary/supplier-spend') {
				columns.push({ 'id': 'supplierName', 'display': 'Supplier', 'renderer': tableRenderService.spendSummaryIdentifierRenderer, 'width': 300});
				columns.push({ 'id': 'supplierCode', 'display': 'Supplier Code', 'width': 150});
			} else if ($state.current.name === 'app.supply-chain.spend-summary/material-group-spend') {
				columns.push({ 'id': 'materialGroup', 'display': 'Material Group', 'renderer': tableRenderService.spendSummaryIdentifierRenderer, 'width': 300});
			} else if ($state.current.name === 'app.supply-chain.spend-summary/item-group-spend') {
				columns.push({ 'id': 'itemGroupName', 'display': 'Item Group', 'renderer': tableRenderService.spendSummaryIdentifierRenderer, 'width': 300});
			}
			columns.push({
				'id': 'totalForAll',
				'display': 'Total<br/>',
				'renderer': tableRenderService.factorySpendRenderer,
				'displayText': 'Total',
				'width': 200,
				'sortDefaultReverse': true
			});
			columns.push({
				'id': 'ppvBaselinePreviousFiscalYear',
				'display': 'PPV Previous Fiscal Year<br />',
				'displayText': 'PPV Previous Fiscal Year',
				'renderer': tableRenderService.ppvRenderer,
				'width': 200,
				'disabled': true
			});
			columns.push({
				'id': 'ppvBaselineCurrentFiscalYear',
				'display': 'PPV Current Fiscal Year<br />',
				'displayText': 'PPV Current Fiscal Year',
				'class': 'alignRight',
				'renderer': tableRenderService.ppvRenderer,
				'width': 200,
				'disabled': true
			});
			columns.push({
				'id': 'futurePPV',
				'display': 'Future PPV<br/>',
				'displayText': 'Future PPV',
				'class': 'alignRight',
				'renderer': tableRenderService.ppvRenderer,
				'width': 200
			});
			var sharedHierarchyColumnProperties = {
				'width': 200,
				'enablePinning': false,
				'disabled': true
			};
			factories.forEach(function (factory) {
				columns.push(Object.assign({'id': 'Sum' + factory.ndx}, sharedHierarchyColumnProperties));
			});
			businessUnits.forEach(function (businessUnit) {
				columns.push(Object.assign({'id': 'SumBU' + businessUnit}, sharedHierarchyColumnProperties));
			});
			divisions.forEach(function (division) {
				columns.push(Object.assign({'id': 'SumDivision' + division}, sharedHierarchyColumnProperties));
			});
			entities.forEach(function (entity) {
				columns.push(Object.assign({'id': 'SumEntity' + entity}, sharedHierarchyColumnProperties));
			});
		}

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			defaultFilters = [
				{ 'id': 'factory', 'values': [$scope.filterService.leanDnaAllSelected], 'isMandatory': true },
				{ 'id': 'fiscalYear', 'values': ['current'] },
				{ 'id': 'spendType', 'values': ['direct'] }
			];
			var siteFilter = $scope.filterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.includeInFilter = true;
			siteFilter.removable = false;
			var filters = [
				$scope.filterService.filterDefinitions['SpendType'],
				$scope.filterService.filterDefinitions['BusinessUnit'],
				$scope.filterService.filterDefinitions['Division'],
				$scope.filterService.filterDefinitions['Entity'],
				siteFilter,
				$scope.filterService.filterDefinitions['Supplier']
			];

			if ($state.current.name === 'app.supply-chain.spend-summary/supplier-spend') {
				// filter.push($scope.filterService.filterDefinitions['Supplier']);
			} else if ($state.current.name === 'app.supply-chain.spend-summary/material-group-spend') {
				filters.push($scope.filterService.filterDefinitions['MaterialGroup']);
			} else if ($state.current.name === 'app.supply-chain.spend-summary/item-group-spend') {
				filters.push($scope.filterService.filterDefinitions['Item Group']);
			}
			$scope.filterService.setMasterFilterList(filters);

			var singleSelectFilters = [
				$scope.filterService.filterDefinitions['FiscalYear'],
				$scope.filterService.filterDefinitions['ViewByBuDivisionEntitySite']
			];
			if(showWhitelistFilter && groupBy === 'supplierCode') {
				singleSelectFilters.push($scope.filterService.filterDefinitions['WhitelistedSuppliers']);
			}
			$scope.filterService.setMasterSingleSelectFilterList(singleSelectFilters);

			setDefaultColumns(true);
		}
	}
})();
